import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, LoadingController } from 'ionic-angular';
import { DataProvider } from "../../providers/data/data";
import { environment } from "../../environments/environment";
import { OrdersPage } from "../orders/orders";
import { HttpClient } from "@angular/common/http";
import { ToastController } from 'ionic-angular';

/**
 * Generated class for the OrdersPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-print',
  templateUrl: 'print.html',
})
export class PrintPage {
  selectedItem: any;
  count = 0;
  count_max = 0;
  pin;
  pv = null;

  constructor(public toastCtrl: ToastController, private http: HttpClient, public loadingCtrl: LoadingController, public navCtrl: NavController, public navParams: NavParams, public data: DataProvider, public viewCtrl: ViewController) {
    this.count_max = this.navParams.data.order.anzahl - this.navParams.data.order.erledigt;
    if (this.count_max > 5) {
      this.count = 5;
    } else {
      this.count = this.count_max;
    }
    if (this.navParams.data.order.pv !== undefined) {
      this.count = 1;
      this.pv = this.navParams.data.order.pv;
    }
  }

  ionViewDidLoad() {
  }

  dismiss() {
    let data = { 'foo': 'bar' };
    this.viewCtrl.dismiss(data);
  }

  increase() {
    if (this.count < 20 && this.count < this.count_max) {
      this.count++;
    }
  }

  decrease() {
    if (this.count > 1) {
      this.count--;
    }
  }

  presentLoadingDefault() {
    let loading = this.loadingCtrl.create({
      content: 'Daten werden an Drucker gesendet.'
    });

    loading.present();

    setTimeout(() => {
      loading.dismiss();
      this.viewCtrl.dismiss();
    }, 5000);
  }

  print() {
    let loading = this.loadingCtrl.create({
      content: 'Daten werden an Drucker gesendet.'
    });
    loading.present();
    const body = {
      token: localStorage.getItem('token'),
      module: 'orders',
      submodule: 'print',
      data: {
        order_id: this.navParams.data.order.id,
        count: this.count,
        pin: this.pin,
        pv: this.pv,
        close: true
      }
    };
    this.http.post(environment.api_url, body).subscribe(daten => {
      loading.dismiss();
      if (daten['data'].code === 1) {
        let toast = this.toastCtrl.create({
          message: daten['message'],
          duration: 3000,
          position: 'middle'
        });
        toast.present();
      } else {
        this.viewCtrl.dismiss(this.count);
      }
      }, error => {
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/pages/print/print.ts